"use client";

import { createContext, use } from "react";

import { AuthFlowContextValue } from "./types";

export const AuthFlowContext = createContext<AuthFlowContextValue | null>(null);

export function useAuthFlow(): AuthFlowContextValue {
  const ctx = use(AuthFlowContext);
  if (!ctx) {
    throw new Error("useAuthFlow must be used inside <AuthFlow>");
  }
  return ctx;
}
